import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { BaseButton } from '../../../../../../BaseComponents';
import { useClearLastExchange } from '../../lib/useClearLastExchange';

interface Props {
	label?: string;
	isLoading?: boolean;
}

const ClearLastExchangeButton: React.FC<Props> = ({ label, isLoading }) => {
	const { t } = useTranslation('Checkout');
	const { onClearLastExchange } = useClearLastExchange();

	return (
		<BaseButton variant="action" isLoading={isLoading} onClick={onClearLastExchange}>
			{label || t('ClearLastExchangeButton.Label')}
		</BaseButton>
	);
};

export default ClearLastExchangeButton;
